import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-806e0022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-view container d-flex justify-content-center py-4 py-md-5" }
const _hoisted_2 = { class: "col-12 col-lg-11 col-xl-9 col-xxl-7" }
const _hoisted_3 = { class: "form" }

import PageHero from "@/components/misc/PageHero.vue";
import LoginForm from "@/components/forms/LoginForm.vue";
import { useHead } from "@unhead/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

useHead({
  title: "Login",
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageHero, {
        eyebrow: "Vasco Mobile",
        title: "Stay connected",
        subtitle: "Recharge, change your deal or check your bill, any time."
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(LoginForm)
      ])
    ])
  ]))
}
}

})